import { render } from "./rooftop.svg?vue&type=template&id=07d71324"
const script = {}
script.render = render

export default script